import { pdsTv } from '@purinanbm/pds-ui';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import { merge } from 'lodash';
import React from 'react';
import { Container } from 'react-bootstrap';
import { CMS_THEME } from '../../common/enums';
import MediaRemoteVideo from '../../components/media/MediaRemoteVideo';
import { StorageContentBlock } from '../common/StorageContentBlock/StorageContentBlock';

type Props = {
  node: IStorageVideo;
};

const DefaultSettings = {
  entity_heading: {
    element: 'h2',
    style: 'typography_h2',
  },
  entity_variant: {
    theme: CMS_THEME.LIGHT,
    text_align: 'center',
  },
};

const styles = pdsTv({
  base: 'pds-px-0 pds-py-4.5 lg-bt:pds-py-5.5',
  variants: {
    theme: {
      light: 'pds-bg-surface pds-text-surface-text',
      dark: 'pds-bg-surface-text pds-text-neutral-text',
      neutral: 'pds-bg-surface-layer pds-text-surface-text',
    },
  },
});

const StorageVideo = ({ node: video }: Props) => {
  const settings = merge({}, DefaultSettings, video?.behaviors);
  const cmsTheme = settings.entity_variant.theme;
  const videoMedia = video.relationships.video;
  const wrapper = styles({ theme: cmsTheme });

  const handleGA = (linkObject: LinkProps) => {
    sendIt({
      event: 'module_interaction',
      eventParams: {
        component_id: video.title,
        component_type: video.type,
        content_name: linkObject.title,
      },
    });
  };

  return (
    <div id={video.component_id} data-id={video.drupal_id} className={wrapper}>
      <Container>
        <StorageContentBlock
          node={{ ...video, behaviors: settings }}
          actionCallback={handleGA}
          className="pds-mb-4 md:pds-mb-5"
        />
        <MediaRemoteVideo
          videoTitle={video.title}
          videoType={video.type}
          cmsTheme={cmsTheme}
          field_media_oembed_video={videoMedia?.field_media_oembed_video}
          field_media_video_transcript={videoMedia?.field_media_video_transcript}
          id={video.id}
          internal={videoMedia?.internal}
        />
      </Container>
    </div>
  );
};

export default StorageVideo;
